import React, { useState, useEffect } from "react";
import { Form, Input, Select } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import toast from "react-hot-toast";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { AddClientApi } from "../../../api/request/auth";
import { GetCountryListApi } from "../../../api/request/countryDetail";
const { Option } = Select;

export default function AddClientForm({ isOpen, setIsOpen, getClient}) {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [countryData, setCountryData] = useState([]);

    const getCountryList = async () => {
        try {
            const { data } = await GetCountryListApi();
            if (data?.status) {
                setCountryData(data?.data);
            }
        }
        catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
        }
    }

    useEffect(() => {
        getCountryList();
    }, [])

    const submitHandler = async (values) => {
        try {
            setIsLoading(true);
            const { data } = await AddClientApi({...values, login_type: 'api'});
            if (data?.status) {
                toast.success(data?.message);
                getClient();
                setIsOpen(false);
            }
        } catch (error) {
            if (error?.response?.data?.message)
                toast.error(error?.response?.data?.message); 
        } finally {
            form.resetFields();
            setIsLoading(false);
        }
    };

    return <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Add Client"
    >
        <Form
            autoComplete="off"
            layout="vertical"
            form={form}
            onFinish={submitHandler}
        >
            <div className='grid lg:grid-flow-col gap-4'>
                <Form.Item
                    label="First Name"
                    name="first_name"
                    rules={[{ required: true, message: "Please enter first name." }]}
                >
                    <Input placeholder="First Name" size="large" />
                </Form.Item>
                <Form.Item
                    label="Last Name"
                    name="last_name"
                    rules={[{ required: true, message: "Please enter last name." }]}
                >
                    <Input placeholder="Last Name" size="large" />
                </Form.Item>
            </div>
            <div className="flex sm:flex-row flex-col sm:gap-4">
                <Form.Item
                    label="Country Code"
                    name="country_code" 
                    className='sm:min-w-[28%]'
                >
                    <Select placeholder='Country code' size="large"  >
                        {countryData?.map((countryCode, index) => (
                            <Option key={index} value={countryCode?.id}>
                                <div className="flex items-center space-x-3">
                                    <div className='rounded-full bg-secondaryLight w-9 h-9 flex justify-center items-center'>
                                        <img src={countryCode?.image} alt="flag" className="w-7 h-7 object-contain rounded-full" />
                                    </div>
                                    <span className='text-base'>+ {countryCode?.phonecode}</span>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Mobile No."
                    name="mobile_no"
                    className="w-full"
                    rules={[
                        {
                            pattern: /^\d{10}$/,
                            message: 'Mobile number should be 10 digits!',
                        },
                    ]}
                >
                    <Input placeholder="Mobile No." type='Number' size="large" />
                </Form.Item>
            </div>
            <Form.Item
                label="Email"
                name="email"
                rules={[
                    { required: true, message: "Please enter email." },
                    { type: "email", message: "Please enter valid email." }
                ]}
            >
                <Input placeholder="Email" size="large" />
            </Form.Item>
            <div className="flex justify-center mt-5">
                <LoadableButton
                    className="bg-primary text-white uppercase text-base font-semibold px-6 py-2 rounded-lg mt-2"
                    type="submit"
                    lable="Submit"
                    loadingLable="Adding Client..."
                    isLoading={isLoading}
                />
            </div>
        </Form>
    </ModalComponent>
}